import { render, staticRenderFns } from "./SingleFlightItemApp.vue?vue&type=template&id=432acbe0&scoped=true"
import script from "./SingleFlightItemApp.vue?vue&type=script&lang=js"
export * from "./SingleFlightItemApp.vue?vue&type=script&lang=js"
import style0 from "./SingleFlightItemApp.vue?vue&type=style&index=0&id=432acbe0&prod&lang=css"
import style1 from "./SingleFlightItemApp.vue?vue&type=style&index=1&id=432acbe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432acbe0",
  null
  
)

export default component.exports